import { ICustomFieldsDTO } from './custom-fields.dao';
import { GetCustomFieldsOptionsList } from './custom-pages.dao';
import { IEventRequestParams } from './shared.dto';

abstract class IRegistrationConfigurationDAO {
    public abstract getRegistrationConfiguration(eventId: number, accountId: number): Promise<IGeneralRegistrationDTO>;

    public abstract updateRegistrationConfiguration(
        accountId: number,
        eventId: number,
        registrationConfiguration: IGeneralRegistrationDTO
    ): Promise<IGeneralRegistrationDTO>;

    public abstract getFormRegistrationConfiguration(eventId: number, accountId: number): Promise<IFormRegistrationConfigurationDTO>;

    public abstract updateFormRegistrationConfiguration(
        accountId: number,
        eventId: number,
        registrationConfiguration: IFormRegistrationConfigurationDTO
    ): Promise<IFormRegistrationConfigurationDTO>;
    public abstract getCustomFieldsOptionsList(eventId: number, accountId: number): Promise<GetCustomFieldsOptionsList>;
    public abstract deleteCustomeField(params: IEventRequestParams & {
        customFieldId: number;
    }): Promise<void>;
}

interface IGeneralRegistrationDTO {
    asLandingPage: boolean;
    blockedDomains: {domain: string}[];
    enabled: boolean;
    registrationFieldsChanges?: { [field: string]: string };
    triagedRegistrationEnabled: boolean;
    triagedQuestionsCreated?: boolean;
    settings: IRegistrationSettings[];
    availableForms?: IAvailableForms[];
    registrationApprovalEnabled: boolean;
    urlParameterRegistrationEnabled: boolean;
}

interface IAvailableForms {
    displayName: string;
    formName: string;
}

interface IRegistrationSettings {
    autoSignInEnabled: boolean;
    calendarButtonEnabled: boolean;
    formName: string;
    header: string;
    instructions: string;
    registrationSubmittedMessage: string;
    pendingDeniedMessage?: string;
    registrationType: RegistrationTypeValue;
    showOpenMeetings: boolean;
}

interface IFormRegistrationConfigurationDTO {
    fields: ICustomFieldsDTO[];
    triagedRegistrationEnabled?: boolean;
}

interface IRegistrationType {
    value: RegistrationTypeValue;
    textInUI: string;
}

enum RegistrationTypeValue {
    OPEN = 'OPEN',
    CONTROLLED = 'CONTROLLED'
}

interface IRegistrationFieldsErrorConfig {
    instructions?: string;
    registrationSubmittedMessage?: string;
    pendingDeniedMessage?: string;
    header?: string;
}

export {
    IRegistrationConfigurationDAO,
    IFormRegistrationConfigurationDTO,
    IGeneralRegistrationDTO,
    RegistrationTypeValue,
    IRegistrationType,
    IRegistrationSettings,
    IRegistrationFieldsErrorConfig,
    IAvailableForms,
};
